import clsx from 'clsx';
import React from 'react';
import BzmIcon from '../../../../components/icons/BzmIcon';
import styles from './AnalyticsDropdown.module.css';

const AnalyticsDropdownToggle = React.forwardRef(
  (props: { onClick: (e: any) => void; onKeyDown: any; children: any; disabled: boolean }, ref: any) => (
    <div
      ref={ref}
      onClick={e => props.onClick(e)}
      onKeyDown={(event: any) => props.onKeyDown(event)}
      className={clsx(styles.toggle, props.disabled ? styles.disabled : 'hand-cursor')}
    >
      <span tabIndex={0} style={{ fontSize: '14px' }}>
        Open
      </span>{' '}
      <BzmIcon variant={'icon-bzm-add'} style={{ fontSize: '18px', position: 'relative', top: '1px' }} />
    </div>
  ),
);
AnalyticsDropdownToggle.displayName = 'AnalyticsDropdownToggle';

export default AnalyticsDropdownToggle;
